/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMath = createReactComponent("outline", "math", "IconMath", [["path", { "d": "M19 5h-7l-4 14l-3 -6h-2", "key": "svg-0" }], ["path", { "d": "M14 13l6 6", "key": "svg-1" }], ["path", { "d": "M14 19l6 -6", "key": "svg-2" }]]);

export { IconMath as default };
//# sourceMappingURL=IconMath.mjs.map
